import type {
  ConnectorCredentialSource,
  ConnectorSourceDisplayFieldDefinition,
} from '../types'

export type WorkdayFilterField =
  | 'requisition_number'
  | 'requester_employee_id'
  | 'created_by_employee_id'
  | 'approver_employee_id'
  | 'sourcing_buyer_employee_id'
  | 'spend_category'
  | 'attachment_filename'

export type WorkdayFilterOperator = 'is' | 'starts-with'

export interface WorkdayFilter {
  field: WorkdayFilterField
  operator: WorkdayFilterOperator
  value: string
}

export interface WorkdayFeedOptions {
  apiUrl: string
  credentialSource: ConnectorCredentialSource
  filters: WorkdayFilter[]
}

export interface WorkdayConnectionStatus {
  workspaceConfigured: boolean | null
  umdConfigured: boolean | null
  umdCredentialKeys: string[]
}

export interface WorkdayWorkspaceCredentials {
  username: string
  password: string
}

export const WORKDAY_DEFAULT_API_URL =
  'https://wd2-impl-services1.workday.com/ccx/service/umd13/Resource_Management/v46.1'

export const WORKDAY_DEFAULT_FILTERS: WorkdayFilter[] = [
  { field: 'spend_category', operator: 'is', value: 'SC00411' },
  {
    field: 'attachment_filename',
    operator: 'starts-with',
    value: 'Software Risk Management Assessment Form',
  },
]

export const workdayFilterLabels: Record<WorkdayFilterField, string> = {
  requisition_number: 'Requisition number',
  requester_employee_id: 'Requester employee ID',
  created_by_employee_id: 'Created-by employee ID',
  approver_employee_id: 'Approver employee ID',
  sourcing_buyer_employee_id: 'Sourcing buyer employee ID',
  spend_category: 'Spend category',
  attachment_filename: 'Attachment filename',
}

export const WORKDAY_SOURCE_DISPLAY_FIELDS: ConnectorSourceDisplayFieldDefinition[] = [
  { key: 'requisition_date', label: 'Requisition date', default: true },
  { key: 'status', label: 'Status', default: true },
  { key: 'requisition_type', label: 'Requisition type', default: true },
  { key: 'requester', label: 'Requester', default: true },
]
